import type { ScreenFn } from "../shell/descriptor.js";
import type { AppStore } from "../state/store.js";
import { controls } from "./controls.js";
import { crossfire } from "./crossfire.js";
import { discover } from "./discover.js";
import { feed } from "./feed.js";
import { follow } from "./follow.js";
import { onbAreas, onbEmail, onbExperts, signin, welcome } from "./onboarding.js";
import { practices } from "./practices.js";
import { review } from "./review.js";
import { today } from "./today.js";
import { expert } from "./expert.js";

export const SCREENS: Record<string, ScreenFn> = {
  welcome,
  "onb-areas": onbAreas,
  "onb-experts": onbExperts,
  "onb-email": () => onbEmail(),
  signin,
  today,
  practices,
  discover,
  feed,
  crossfire,
  follow,
  expert,
  controls,
  review,
  // about, contact, privacy, terms and health are not screens (2 Aug 2026):
  // their routes open a modal over the screen the reader belongs on. See
  // `landingFor` in the store.
};

export type { AppStore };
